import { forwardRef } from 'react';
import t from 'common/i18n';
import Button from 'root/components/Button';
import './UploadButton.scss';

const UploadButton = forwardRef(({ allowedFormat }, ref) => (
  <div className="upload_button_holder" ref={ref}>
    <input type="file" name="file" className="cloudinary_fileupload" accept={allowedFormat} tabIndex={-1} />
    <Button colorName="link" text={t('local.browse')} tabIndex={0} />
  </div>
));

export default UploadButton;
